import { useDynamicDialog } from '~/composables/dynamic-dialog';
import { ModalNames } from '~/types/modals';

// The one way a gated control says "your plan does not include this". The dialog asks the shared
// licence gate for the offer (assign a spare seat, buy, or upgrade), so a caller names only the
// capability.
export const useFeatureLockedModal = () => {
    function openFeatureModal(feature: string) {
        // A static upsell holds no in-flight work, so Escape and a mask click are ordinary ways
        // out — the dialog default guards modals that would lose a request.
        useDynamicDialog(
            ModalNames.FEATURE_LOCKED,
            { feature },
            {
                label: `${feature} requires a license`,
                closeOnEscape: true,
                dismissableMask: true,
            },
        );
    }

    return { openFeatureModal };
};
